import {AppConfig} from 'appConfig';
import {getUrlRelativeToPublicPath} from '../../common/public-path';
import appConfig from '../../config/app-config';

export const resolveLogoImgUrl = (...variantsAppConfigFieldNames: Array<keyof AppConfig>): string => {
    let result: string = '';

    for (const key of variantsAppConfigFieldNames) {
        const value = appConfig[key] as string;

        if (value) {
            result = getUrlRelativeToPublicPath(`assets/${value}`);
            break;
        }
    }

    return result;
};
